import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-154f7e0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "general" }
const _hoisted_2 = { class: "flex-container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"encabezado\" data-v-154f7e0a><h3 class=\"titulocentro\" data-v-154f7e0a> Clínica Cruz Jiminián </h3><h5 class=\"titulocentro\" data-v-154f7e0a> Av. Ortega y Gasset, No. 90, Santo Domingo, Rep. Dom. </h5><h5 class=\"titulocentro\" data-v-154f7e0a> 809-566-2271 </h5><h5 class=\"titulocentro\" data-v-154f7e0a> RNC: 101149868 </h5></div>", 1)
const _hoisted_4 = {
  class: "encabezado",
  style: {"margin-top":"18px"}
}
const _hoisted_5 = { class: "titulocentro" }
const _hoisted_6 = { class: "titulocentro" }
const _hoisted_7 = { class: "titulocentro" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-label" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label2" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Datos del Prestador")
], -1))
const _hoisted_11 = { class: "grid" }
const _hoisted_12 = { class: "field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NOMBRE: ", -1))
const _hoisted_14 = { class: "field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "APELLIDO: ", -1))
const _hoisted_16 = { class: "field" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "SEXO: ", -1))
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "CEDULA: ", -1))
const _hoisted_20 = { class: "field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NSS: ", -1))
const _hoisted_22 = { class: "field" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "REGIMEN: ", -1))
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "TELEFONO: ", -1))
const _hoisted_26 = { class: "field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "TIPO DE CONTACTO: ", -1))
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NOMBRE DE CONTACTO: ", -1))
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "UNAP: ", -1))
const _hoisted_32 = { class: "field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "REGION: ", -1))
const _hoisted_34 = { class: "field" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PROVINCIA: ", -1))
const _hoisted_36 = { class: "field" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "MUNICIPIO: ", -1))
const _hoisted_38 = { class: "field" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ESTADO: ", -1))
const _hoisted_40 = { class: "field" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "TALLA: ", -1))
const _hoisted_42 = { class: "field" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PESO: ", -1))
const _hoisted_44 = { class: "field" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "CINTURA: ", -1))
const _hoisted_46 = { class: "field" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ABDOMEN: ", -1))
const _hoisted_48 = { class: "field" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "CADERA: ", -1))
const _hoisted_50 = { class: "field" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ALTURA DE RODILLA: ", -1))
const _hoisted_52 = { class: "field" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "CINTURA / CADERA: ", -1))
const _hoisted_54 = { class: "field" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PRESION ARTERIAL SISTOLICA: ", -1))
const _hoisted_56 = { class: "field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PRESION ARTERIAL DIASTOLICA: ", -1))
const _hoisted_58 = { class: "field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FRECUENCIA CARDIACA: ", -1))
const _hoisted_60 = { class: "field" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FUERZA: ", -1))
const _hoisted_62 = { class: "field" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "IMC: ", -1))
const _hoisted_64 = { class: "field" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FLEXIBILIDAD MIEMBROS SUPERIORES: ", -1))
const _hoisted_66 = { class: "field" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FLEXIBILIDAD MIEMBROS INFERIORES: ", -1))
const _hoisted_68 = { class: "field" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PLIEGUE DE BICEPS: ", -1))
const _hoisted_70 = { class: "field" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PLIEGUE ABDOMINAL: ", -1))
const _hoisted_72 = { class: "field" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PLIEGUE SUBESCAPULAR: ", -1))
const _hoisted_74 = { class: "field" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ENCAMADO: ", -1))
const _hoisted_76 = { class: "field" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EDENTULO: ", -1))
const _hoisted_78 = { class: "field" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "VIVE SOLO: ", -1))
const _hoisted_80 = { class: "field" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ABANDONO: ", -1))
const _hoisted_82 = { class: "field" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "MALTRATO: ", -1))
const _hoisted_84 = { class: "field" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EXCESO DE MEDICAMENTO: ", -1))
const _hoisted_86 = { class: "field" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PSIQUIATRIA: ", -1))
const _hoisted_88 = { class: "field" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "GERIATRIA: ", -1))
const _hoisted_90 = { class: "field" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ORTOPEDIA: ", -1))
const _hoisted_92 = { class: "field" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "GASTROENTEROLOGIA: ", -1))
const _hoisted_94 = { class: "field" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "OFTALMOLOGIA: ", -1))
const _hoisted_96 = { class: "field" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PSICOLOGIA: ", -1))
const _hoisted_98 = { class: "field" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NEUROLOGIA: ", -1))
const _hoisted_100 = { class: "field" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FISIATRIA: ", -1))
const _hoisted_102 = { class: "field" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "CARDIOLOGIA: ", -1))
const _hoisted_104 = { class: "field" }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ODONTOLOGIA: ", -1))
const _hoisted_106 = { class: "field" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "UROLOGIA: ", -1))
const _hoisted_108 = { class: "field" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "DIABETOLOGIA: ", -1))
const _hoisted_110 = { class: "field" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ANDADOR DE 4 RUEDAS: ", -1))
const _hoisted_112 = { class: "field" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ANDADOR DE 4 PATAS: ", -1))
const _hoisted_114 = { class: "field" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "BASTON: ", -1))
const _hoisted_116 = { class: "field" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "BASTON DE 4 PATAS: ", -1))
const _hoisted_118 = { class: "field" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "BASTON BLANCO (NO VIDENTE): ", -1))
const _hoisted_120 = { class: "field" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "CAMA DE POSICION: ", -1))
const _hoisted_122 = { class: "field" }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "COLCHON DE AIRE: ", -1))
const _hoisted_124 = { class: "field" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FAJA ABDOMINAL: ", -1))
const _hoisted_126 = { class: "field" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "GLUCOMETRO: ", -1))
const _hoisted_128 = { class: "field" }
const _hoisted_129 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "INODORO PORTATIL: ", -1))
const _hoisted_130 = { class: "field" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "MULETAS: ", -1))
const _hoisted_132 = { class: "field" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PAMPERS XL: ", -1))
const _hoisted_134 = { class: "field" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PAMPERS L: ", -1))
const _hoisted_136 = { class: "field" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PAMPERS M: ", -1))
const _hoisted_138 = { class: "field" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "PAMPERS S: ", -1))
const _hoisted_140 = { class: "field" }
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "SILLA DE BAÑO: ", -1))
const _hoisted_142 = { class: "field" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "MEDIA DE COMPRESION: ", -1))
const _hoisted_144 = { class: "field" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FECHA: ", -1))
const _hoisted_146 = { class: "field" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "KIT: ", -1))
const _hoisted_148 = { class: "field" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "NOMBRE DEL DOCTOR: ", -1))
const _hoisted_150 = { class: "field" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 1: ", -1))
const _hoisted_152 = { class: "field" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 2: ", -1))
const _hoisted_154 = { class: "field" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 3: ", -1))
const _hoisted_156 = { class: "field" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 4: ", -1))
const _hoisted_158 = { class: "field" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 5: ", -1))
const _hoisted_160 = { class: "field" }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 6: ", -1))
const _hoisted_162 = { class: "field" }
const _hoisted_163 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 7: ", -1))
const _hoisted_164 = { class: "field" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 8: ", -1))
const _hoisted_166 = { class: "field" }
const _hoisted_167 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 9: ", -1))
const _hoisted_168 = { class: "field" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EVALUACION NUTRICIONAL 10: ", -1))
const _hoisted_170 = { class: "field" }
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "FECHA DE NACIMIENTO: ", -1))
const _hoisted_172 = { class: "field" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "EDAD: ", -1))
const _hoisted_174 = { class: "field" }
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "DIRECCION: ", -1))
const _hoisted_176 = { class: "field" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "STATUS: ", -1))
const _hoisted_178 = { class: "field" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ID CENTRO: ", -1))
const _hoisted_180 = { class: "field" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ID PACIENTE: ", -1))
const _hoisted_182 = { class: "field" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ID EVALUACION: ", -1))
const _hoisted_184 = { class: "field" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "bold" }, "ID DOCTOR: ", -1))
const _hoisted_186 = /*#__PURE__*/_createStaticVNode("<br data-v-154f7e0a><br data-v-154f7e0a><br data-v-154f7e0a><br data-v-154f7e0a><br data-v-154f7e0a><br data-v-154f7e0a><div class=\"flex-container2\" data-v-154f7e0a><div data-v-154f7e0a><p class=\"field bold\" data-v-154f7e0a>________________________________</p><p class=\"field bold\" data-v-154f7e0a>Firma y Sello del PSS</p></div><div data-v-154f7e0a><p class=\"field bold\" data-v-154f7e0a>________________________________</p><p class=\"field bold\" data-v-154f7e0a>Firma del Familiar o Paciente</p></div></div><br data-v-154f7e0a><br data-v-154f7e0a><br data-v-154f7e0a>", 10)
const _hoisted_196 = { class: "field clausule" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h4", _hoisted_5, "Fecha: " + _toDisplayString(_ctx.formatDate(this.fechaActual)), 1),
        _createElementVNode("h4", _hoisted_6, "Hora: " + _toDisplayString(_ctx.formatTime(this.fechaActual)), 1),
        _createElementVNode("h4", _hoisted_7, "Factura No.: " + _toDisplayString(this.evaluacion.facNo), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("label", _hoisted_9, [
        _createElementVNode("b", null, _toDisplayString(this.titulo), 1)
      ]),
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("p", _hoisted_12, [
          _hoisted_13,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.nombre), 1)
        ]),
        _createElementVNode("p", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.apellido), 1)
        ]),
        _createElementVNode("p", _hoisted_16, [
          _hoisted_17,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.sexo), 1)
        ]),
        _createElementVNode("p", _hoisted_18, [
          _hoisted_19,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.cedula), 1)
        ]),
        _createElementVNode("p", _hoisted_20, [
          _hoisted_21,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.nss), 1)
        ]),
        _createElementVNode("p", _hoisted_22, [
          _hoisted_23,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.regimen), 1)
        ]),
        _createElementVNode("p", _hoisted_24, [
          _hoisted_25,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.telefono), 1)
        ]),
        _createElementVNode("p", _hoisted_26, [
          _hoisted_27,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.tipo_de_contacto), 1)
        ]),
        _createElementVNode("p", _hoisted_28, [
          _hoisted_29,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.nombre_contacto), 1)
        ]),
        _createElementVNode("p", _hoisted_30, [
          _hoisted_31,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.unap), 1)
        ]),
        _createElementVNode("p", _hoisted_32, [
          _hoisted_33,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.region), 1)
        ]),
        _createElementVNode("p", _hoisted_34, [
          _hoisted_35,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.provincia), 1)
        ]),
        _createElementVNode("p", _hoisted_36, [
          _hoisted_37,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.municipio), 1)
        ]),
        _createElementVNode("p", _hoisted_38, [
          _hoisted_39,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.estado), 1)
        ]),
        _createElementVNode("p", _hoisted_40, [
          _hoisted_41,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.talla), 1)
        ]),
        _createElementVNode("p", _hoisted_42, [
          _hoisted_43,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.peso), 1)
        ]),
        _createElementVNode("p", _hoisted_44, [
          _hoisted_45,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.cintura), 1)
        ]),
        _createElementVNode("p", _hoisted_46, [
          _hoisted_47,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.abdomen), 1)
        ]),
        _createElementVNode("p", _hoisted_48, [
          _hoisted_49,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.cadera), 1)
        ]),
        _createElementVNode("p", _hoisted_50, [
          _hoisted_51,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.altura_rodilla), 1)
        ]),
        _createElementVNode("p", _hoisted_52, [
          _hoisted_53,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.Cintura / _ctx.Cadera), 1)
        ]),
        _createElementVNode("p", _hoisted_54, [
          _hoisted_55,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.presion_arterial_sistolica), 1)
        ]),
        _createElementVNode("p", _hoisted_56, [
          _hoisted_57,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.presion_arterial_diatolica), 1)
        ]),
        _createElementVNode("p", _hoisted_58, [
          _hoisted_59,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.frecuencia_cardiaca), 1)
        ]),
        _createElementVNode("p", _hoisted_60, [
          _hoisted_61,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.fuerza), 1)
        ]),
        _createElementVNode("p", _hoisted_62, [
          _hoisted_63,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.imc), 1)
        ]),
        _createElementVNode("p", _hoisted_64, [
          _hoisted_65,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.flexibilidad_miembro_superior), 1)
        ]),
        _createElementVNode("p", _hoisted_66, [
          _hoisted_67,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.flexibilidad_miembro_inferior), 1)
        ]),
        _createElementVNode("p", _hoisted_68, [
          _hoisted_69,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.pliegue_bicep), 1)
        ]),
        _createElementVNode("p", _hoisted_70, [
          _hoisted_71,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.pliegue_abdominal), 1)
        ]),
        _createElementVNode("p", _hoisted_72, [
          _hoisted_73,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.pliegue_sub), 1)
        ]),
        _createElementVNode("p", _hoisted_74, [
          _hoisted_75,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.Encamado), 1)
        ]),
        _createElementVNode("p", _hoisted_76, [
          _hoisted_77,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.Edentulo), 1)
        ]),
        _createElementVNode("p", _hoisted_78, [
          _hoisted_79,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["vive solo"]), 1)
        ]),
        _createElementVNode("p", _hoisted_80, [
          _hoisted_81,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.abandono), 1)
        ]),
        _createElementVNode("p", _hoisted_82, [
          _hoisted_83,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.maltrato), 1)
        ]),
        _createElementVNode("p", _hoisted_84, [
          _hoisted_85,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["exceso medicamento"]), 1)
        ]),
        _createElementVNode("p", _hoisted_86, [
          _hoisted_87,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_psiqui), 1)
        ]),
        _createElementVNode("p", _hoisted_88, [
          _hoisted_89,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_geria), 1)
        ]),
        _createElementVNode("p", _hoisted_90, [
          _hoisted_91,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_orto), 1)
        ]),
        _createElementVNode("p", _hoisted_92, [
          _hoisted_93,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_gastro), 1)
        ]),
        _createElementVNode("p", _hoisted_94, [
          _hoisted_95,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_oftal), 1)
        ]),
        _createElementVNode("p", _hoisted_96, [
          _hoisted_97,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_psicolo), 1)
        ]),
        _createElementVNode("p", _hoisted_98, [
          _hoisted_99,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_neurolo), 1)
        ]),
        _createElementVNode("p", _hoisted_100, [
          _hoisted_101,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_fisia), 1)
        ]),
        _createElementVNode("p", _hoisted_102, [
          _hoisted_103,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_cardio), 1)
        ]),
        _createElementVNode("p", _hoisted_104, [
          _hoisted_105,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_odonto), 1)
        ]),
        _createElementVNode("p", _hoisted_106, [
          _hoisted_107,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_urolo), 1)
        ]),
        _createElementVNode("p", _hoisted_108, [
          _hoisted_109,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.specialist_appo_diabe), 1)
        ]),
        _createElementVNode("p", _hoisted_110, [
          _hoisted_111,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Andador 4 Ruedas"]), 1)
        ]),
        _createElementVNode("p", _hoisted_112, [
          _hoisted_113,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Andador 4 Patas"]), 1)
        ]),
        _createElementVNode("p", _hoisted_114, [
          _hoisted_115,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.Bastón), 1)
        ]),
        _createElementVNode("p", _hoisted_116, [
          _hoisted_117,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Bastón 4 P"]), 1)
        ]),
        _createElementVNode("p", _hoisted_118, [
          _hoisted_119,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Bastón No VIdente"]), 1)
        ]),
        _createElementVNode("p", _hoisted_120, [
          _hoisted_121,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Cama de Posición"]), 1)
        ]),
        _createElementVNode("p", _hoisted_122, [
          _hoisted_123,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Colchón Aire"]), 1)
        ]),
        _createElementVNode("p", _hoisted_124, [
          _hoisted_125,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Faja Obdominal"]), 1)
        ]),
        _createElementVNode("p", _hoisted_126, [
          _hoisted_127,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.Glucómetro), 1)
        ]),
        _createElementVNode("p", _hoisted_128, [
          _hoisted_129,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Inodoro Porta"]), 1)
        ]),
        _createElementVNode("p", _hoisted_130, [
          _hoisted_131,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.Muletas), 1)
        ]),
        _createElementVNode("p", _hoisted_132, [
          _hoisted_133,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Pampers XL"]), 1)
        ]),
        _createElementVNode("p", _hoisted_134, [
          _hoisted_135,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Pampers L"]), 1)
        ]),
        _createElementVNode("p", _hoisted_136, [
          _hoisted_137,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Pampers M"]), 1)
        ]),
        _createElementVNode("p", _hoisted_138, [
          _hoisted_139,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Pampers S"]), 1)
        ]),
        _createElementVNode("p", _hoisted_140, [
          _hoisted_141,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Silla de Baño"]), 1)
        ]),
        _createElementVNode("p", _hoisted_142, [
          _hoisted_143,
          _createTextVNode(_toDisplayString(_ctx.evaluacion["Media de Comprensión"]), 1)
        ]),
        _createElementVNode("p", _hoisted_144, [
          _hoisted_145,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.fecha), 1)
        ]),
        _createElementVNode("p", _hoisted_146, [
          _hoisted_147,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.kit), 1)
        ]),
        _createElementVNode("p", _hoisted_148, [
          _hoisted_149,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.nombre_doctor), 1)
        ]),
        _createElementVNode("p", _hoisted_150, [
          _hoisted_151,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_1), 1)
        ]),
        _createElementVNode("p", _hoisted_152, [
          _hoisted_153,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_2), 1)
        ]),
        _createElementVNode("p", _hoisted_154, [
          _hoisted_155,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_3), 1)
        ]),
        _createElementVNode("p", _hoisted_156, [
          _hoisted_157,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_4), 1)
        ]),
        _createElementVNode("p", _hoisted_158, [
          _hoisted_159,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_5), 1)
        ]),
        _createElementVNode("p", _hoisted_160, [
          _hoisted_161,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_6), 1)
        ]),
        _createElementVNode("p", _hoisted_162, [
          _hoisted_163,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_7), 1)
        ]),
        _createElementVNode("p", _hoisted_164, [
          _hoisted_165,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_8), 1)
        ]),
        _createElementVNode("p", _hoisted_166, [
          _hoisted_167,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_9), 1)
        ]),
        _createElementVNode("p", _hoisted_168, [
          _hoisted_169,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.eval_nutri_10), 1)
        ]),
        _createElementVNode("p", _hoisted_170, [
          _hoisted_171,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.fechaNacimiento), 1)
        ]),
        _createElementVNode("p", _hoisted_172, [
          _hoisted_173,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.edad), 1)
        ]),
        _createElementVNode("p", _hoisted_174, [
          _hoisted_175,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.direccion), 1)
        ]),
        _createElementVNode("p", _hoisted_176, [
          _hoisted_177,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.status), 1)
        ]),
        _createElementVNode("p", _hoisted_178, [
          _hoisted_179,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.id_center), 1)
        ]),
        _createElementVNode("p", _hoisted_180, [
          _hoisted_181,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.id_patient), 1)
        ]),
        _createElementVNode("p", _hoisted_182, [
          _hoisted_183,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.id_form), 1)
        ]),
        _createElementVNode("p", _hoisted_184, [
          _hoisted_185,
          _createTextVNode(_toDisplayString(_ctx.evaluacion.id_doctor), 1)
        ])
      ]),
      _hoisted_186,
      _createElementVNode("div", null, [
        _createElementVNode("p", _hoisted_196, " Por este medio autorizo a la CLINICA CRUZ JIMINIAN, a suministrar toda información que sea solicitada por " + _toDisplayString(this.evaluacion.nombARS) + ", correspondiente a todo tratamiento, servicio, estudio, laboratorio, diagnóstico o beneficios prestador a mi favor. ", 1)
      ])
    ])
  ]))
}